import React, { useState } from 'react';
import { Table, Button, Form, Row, Col } from 'react-bootstrap';
import { FiEdit, FiTrash2 } from 'react-icons/fi';

const UserTable = ({ usuarios, onEdit, onDelete }) => {
  const [filtroRol, setFiltroRol] = useState('');
  const [fechaDesde, setFechaDesde] = useState('');
  const [fechaHasta, setFechaHasta] = useState('');

  const usuariosFiltrados = usuarios.filter(u => {
    const cumpleRol = filtroRol ? u.role === filtroRol : true;
    const fechaCreacion = new Date(u.createdAt);
    const desde = fechaDesde ? new Date(fechaDesde) : null;
    const hasta = fechaHasta ? new Date(fechaHasta) : null;
    const cumpleFecha =
      (!desde || fechaCreacion >= desde) &&
      (!hasta || fechaCreacion <= hasta);
    return cumpleRol && cumpleFecha;
  });

  const rolesUnicos = [...new Set(usuarios.map(u => u.role))];

  return (
    <div>
      <h4 className="mb-3">👥 Usuarios del Local</h4>

      <Row className="mb-3">
        <Col md={4}>
          <Form.Select value={filtroRol} onChange={e => setFiltroRol(e.target.value)}>
            <option value="">Todos los roles</option>
            {rolesUnicos.map(rol => (
              <option key={rol} value={rol}>
                {rol}
              </option>
            ))}
          </Form.Select>
        </Col>
        <Col md={3}>
          <Form.Control
            type="date"
            value={fechaDesde}
            onChange={e => setFechaDesde(e.target.value)}
            placeholder="Desde"
          />
        </Col>
        <Col md={3}>
          <Form.Control
            type="date"
            value={fechaHasta}
            onChange={e => setFechaHasta(e.target.value)}
            placeholder="Hasta"
          />
        </Col>
        <Col md={2}>
          <Button
            variant="secondary"
            onClick={() => {
              setFiltroRol('');
              setFechaDesde('');
              setFechaHasta('');
            }}
          >
            Limpiar filtros
          </Button>
        </Col>
      </Row>

      <Table responsive bordered hover>
        <thead className="table-light">
          <tr>
            <th>Nombre</th>
            <th>Email</th>
            <th>Rol</th>
            <th>Fecha Alta</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {usuariosFiltrados.map(u => (
            <tr key={u.id}>
              <td>{u.name}</td>
              <td>{u.email}</td>
              <td>{u.role}</td>
              <td>{new Date(u.createdAt).toLocaleString('es-AR')}</td>
              <td>
                <Button size="sm" variant="outline-warning" className="me-2" onClick={() => onEdit(u)}>
                  <FiEdit className="me-1" /> Editar
                </Button>
                <Button size="sm" variant="outline-danger" onClick={() => onDelete(u.id)}>
                  <FiTrash2 className="me-1" /> Eliminar
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default UserTable;
